// import React from 'react';
// import { Container, Box, Typography, Grid } from '@mui/material';
// import Hero from '../components/Hero';
// import { SEO } from '../utils/seo';
// import meta from '../seo/keywords';
// import heroAbout from '../assets/images/hero-about.jpg';

// const longCopy = [
//   "Rite HVAC Services was founded to bring dependable, technically sound heating and cooling to Bloomington IN. Our mission is simple: earn trust with rigorous diagnostics, thoughtful options, and craftsmanship that holds up under Indiana weather.",
//   "Our values guide every call: safety, clarity, respect for your space, and relentless follow-through. Technicians arrive prepared—with common parts, protective gear, and checklists that ensure nothing is missed. We photograph findings so you can see what we see.",
//   "Certifications matter because quality matters. Our team maintains EPA and NATE credentials and stays current on Energy Star guidelines, SEER2 standards, and evolving refrigerant regulations. Whether we are commissioning a new heat pump or tuning a commercial RTU, we test, verify, and document performance.",
//   "Community is at the heart of our company. We hire locally, invest in training, and support energy-saving programs that reduce monthly bills for families and small businesses. From Ellettsville to Bedford, from Martinsville to Spencer, we’re proud to be the local team that shows up when it counts."
// ].join("\n\n");

// export default function About() {
//   const m = meta.about;
//   return (
//     <Box>
//       <SEO title={m.title} description={m.description} canonical={m.canonical} />
//       <Hero title="Built on Craft, Backed by Certifications" subtitle="EPA · NATE · Energy Star-aligned. A Bloomington IN HVAC partner you can trust." bgImage={heroAbout} />
//       <Container maxWidth="lg" sx={{ py: 6 }}>
//         <Grid container spacing={4}>
//           <Grid item xs={12} md={7}>
//             <Typography variant="h2" gutterBottom>Our Mission & Values</Typography>
//             <Typography paragraph>{longCopy}</Typography>
//             <Typography variant="h3" sx={{ mt: 4 }}>Certifications</Typography>
//             <ul>
//               <li><strong>EPA 608:</strong> Safe and lawful handling of refrigerants.</li>
//               <li><strong>NATE Certified:</strong> Proven knowledge across service and installation.</li>
//               <li><strong>Energy Star:</strong> Best-practice commissioning for efficient operation.</li>
//             </ul>
//             <Typography variant="h3" sx={{ mt: 4 }}>Timeline</Typography>
//             <ul>
//               <li><strong>2015:</strong> Rite HVAC Services launches in Bloomington, IN.</li>
//               <li><strong>2017:</strong> Expanded to commercial maintenance and energy audits.</li>
//               <li><strong>2020:</strong> Added high-velocity and ductless expertise for retrofits.</li>
//               <li><strong>2023:</strong> 24/7 emergency service team launched.</li>
//               <li><strong>2025:</strong> 5,000+ systems tuned, repaired, or replaced across Monroe County.</li>
//             </ul>
//           </Grid>
//           {/* <Grid item xs={12} md={5}>
//             <Box component="img" src="/src/assets/images/gallery-01.svg" alt="Team" sx={{ width: '100%', borderRadius: 2, border:'1px solid #eee', mb: 2 }} />
//             <Box component="img" src="/src/assets/images/gallery-02.svg" alt="Vans" sx={{ width: '100%', borderRadius: 2, border:'1px solid #eee' }} />
//           </Grid> */}
//         </Grid>
//       </Container>
//     </Box>
//   );
// }
import React from 'react';
import { Container, Box, Typography, Grid, List, ListItem, ListItemText } from '@mui/material';
import Hero from '../components/Hero';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import heroAbout from '../assets/images/hero-about.jpg';

export default function About() {
  const m = meta.about;

  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero
        title="Built on Craft, Backed by Certifications"
        subtitle="EPA · NATE · Energy Star-aligned. A Bloomington IN HVAC partner you can trust."
        bgImage={heroAbout}
      />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Typography variant="h2" gutterBottom>Our Mission & Values</Typography>

            <Typography paragraph>
              Rite HVAC Services was founded to bring dependable, technically sound heating and cooling to Bloomington, IN.
              We’re committed to earning your trust through skilled diagnostics, transparent recommendations, and craftsmanship
              that endures Indiana weather.
            </Typography>

            <Typography variant="h3" sx={{ mt: 3 }}>What Drives Us</Typography>
            <List sx={{ listStyleType: 'disc', pl: 4 }}>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Safety first — we follow strict procedures and protective protocols on every job." />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Clarity — clear communication and visual documentation so you always understand our findings." />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Respect — we treat your home or business as carefully as our own." />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Follow-through — every service call ends with verified results and complete cleanup." />
              </ListItem>
            </List>

            <Typography variant="h3" sx={{ mt: 4 }}>Certifications</Typography>
            <List sx={{ listStyleType: 'disc', pl: 4 }}>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="EPA 608 — certified in safe, lawful handling of refrigerants." />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="NATE Certified — verified expertise in HVAC service and installation." />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Energy Star Aligned — ensuring efficiency, SEER2 compliance, and responsible energy use." />
              </ListItem>
            </List>

            <Typography variant="h3" sx={{ mt: 4 }}>Community Commitment</Typography>
            <Typography paragraph>
              We hire locally, invest in technician training, and support programs that lower monthly energy costs for
              families and small businesses. From Ellettsville to Bedford, from Martinsville to Spencer, we’re proud to
              be the team that shows up when it counts.
            </Typography>

            <Typography variant="h3" sx={{ mt: 4 }}>Preventive Maintenance & 24/7 Support</Typography>
            <Typography paragraph>
              Our EPA and NATE certified technicians provide fast, 24/7 emergency response and affordable preventive
              maintenance plans to keep your systems running at peak efficiency. From air conditioners and furnaces
              to heat pumps, boilers, and duct cleaning — we deliver comfort you can count on, year after year.
            </Typography>

            <Typography variant="h3" sx={{ mt: 4 }}>Timeline</Typography>
            <List sx={{ listStyleType: 'disc', pl: 4 }}>
              <ListItem sx={{ display: 'list-item' }}><ListItemText primary="2015 — Rite HVAC Services launches in Bloomington, IN." /></ListItem>
              <ListItem sx={{ display: 'list-item' }}><ListItemText primary="2017 — Expanded to commercial maintenance and energy audits." /></ListItem>
              <ListItem sx={{ display: 'list-item' }}><ListItemText primary="2020 — Added high-velocity and ductless expertise for retrofits." /></ListItem>
              <ListItem sx={{ display: 'list-item' }}><ListItemText primary="2023 — 24/7 emergency service team launched." /></ListItem>
              <ListItem sx={{ display: 'list-item' }}><ListItemText primary="2025 — 5,000+ systems tuned, repaired, or replaced across Monroe County." /></ListItem>
            </List>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
